import styles from './styles/app.module.scss';
import Header from './components/header';
import Hero from './components/hero';
import Conditions from './components/conditions';
import Form from './components/form';
import ThankYou from "./components/thank-you";
import {useState} from "react";

localStorage.setItem('i18nextLng', window.location.pathname.startsWith('/th') ? 'th' : 'en');

function App() {

    const [showThankYou, setShowThankYou] = useState(false);
    const [catalogUrl, setCatalogUrl] = useState({});

    return (
        <main className={styles.mainContainer}>
            <Header/>
            {
                !showThankYou ? (
                    <>
                        <Hero/>
                        <div className={styles.lowerSection}>
                            <Conditions/>
                            <div className={styles.divider}/>
                            <Form setShowThankYou={setShowThankYou} setCatalogUrl={setCatalogUrl}/>
                        </div>
                    </>
                ) : <ThankYou catalogUrl={catalogUrl}/>
            }
        </main>
    );
}

export default App;
